<template>
  <v-app>
    <v-container fluid>

      <v-row>
        <v-col cols="12">

          <v-expansion-panels v-model="panel">

            <v-expansion-panel>

              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Price Inquiry Records
              </v-expansion-panel-title>

              <v-expansion-panel-text>

                <v-card class="pa-4">

                  <!-- FILTER -->
                  <v-row class="mb-3">

                    <v-col md="3" cols="12">
                      <v-date-input
                        label="From Date"
                        v-model="from_date"
                        density="compact"
                        variant="outlined"
                        prepend-icon=""
                        clearable
                        hide-details
                      />
                    </v-col>

                    <v-col md="3" cols="12">
                      <v-date-input
                        label="To Date"
                        v-model="to_date"
                        density="compact"
                        variant="outlined"
                        prepend-icon=""
                        clearable
                        hide-details
                      />
                    </v-col>

                    <v-col md="4" cols="12">
                      <v-autocomplete
                        label="Customer"
                        v-model="customer_id"
                        :items="getCustomerList"
                        item-title="company_name"
                        item-value="id"
                        density="compact"
                        variant="outlined"
                        clearable
                        hide-details
                      />
                    </v-col>

                    <v-col
                      md="2"
                      cols="12"
                      class="d-flex align-center"
                    >
                      <v-btn
                        color="primary"
                        block
                        @click="loadPriceInquiryList"
                      >
                        Search
                      </v-btn>
                    </v-col>

                  </v-row>

                  <!-- TABLE -->
                  <v-data-table
                    :headers="headers"
                    :items="getPriceInquiryList"
                    item-value="id"
                    class="elevation-1"
                  >

                    <!-- SL -->
                    <template #item.index="{ index }">
                      {{ ++index }}
                    </template>

                    <!-- Customer -->
                    <template #item.customer="{ item }">
                      {{
                        item?.customer?.company_name || "N/A"
                      }}
                    </template>

                    <!-- Lead -->
                    <template #item.lead="{ item }">
                      {{
                        item?.lead?.name || "N/A"
                      }}
                    </template>

                    <!-- Representative -->
                    <template #item.representative="{ item }">
                      {{
                        item?.representative?.name || "N/A"
                      }}
                    </template>

                    <!-- Final Price -->
                    <template #item.final_price="{ item }">
                      {{ item.final_price || 0 }}
                    </template>

                    <!-- Status -->
                    <template #item.status="{ item }">

                      <v-chip
                        v-if="item.status == 1"
                        color="success"
                        size="small"
                      >
                        Active
                      </v-chip>

                      <v-chip
                        v-else
                        color="grey"
                        size="small"
                      >
                        Draft
                      </v-chip>

                    </template>

                    <!-- Details Count -->
                    <template #item.details_count="{ item }">
                      {{
                        item?.details?.length || 0
                      }}
                    </template>

                    <!-- Actions -->
                    <template #item.actions="{ item }">

                      <!-- VIEW -->
                      <v-icon
                        small
                        color="blue"
                        class="me-2 edit-button"
                        title="View"
                        @click="viewItem(item)"
                      >
                        mdi-file-document-outline
                      </v-icon>

                      <!-- EDIT -->
                      <v-icon
                        small
                        color="primary"
                        class="me-2 edit-button"
                        title="Edit"
                        v-if="!item.calculation_details"
                        @click="editItem(item)"
                      >
                        mdi-pencil-outline
                      </v-icon>

                    </template>

                  </v-data-table>

                </v-card>

              </v-expansion-panel-text>

            </v-expansion-panel>

          </v-expansion-panels>

        </v-col>
      </v-row>

    </v-container>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";

import { useStore } from "vuex";
import { useRouter } from "vue-router";

import { toast } from "vue3-toastify";

const store = useStore();
const router = useRouter();

const panel = ref([0]);

const selectedItem = ref(null);

const from_date = ref(null);
const to_date = ref(null);

const customer_id = ref(null);

/* ================= HEADERS ================= */

const headers = [

  {
    title: "#SL",
    align: "center",
    key: "index"
  },

  {
    title: "Code",
    key: "code"
  },

  {
    title: "Customer",
    key: "customer"
  },

  {
    title: "Lead",
    key: "lead"
  },

  {
    title: "Representative",
    key: "representative"
  },

  {
    title: "Final Price",
    key: "final_price"
  },

  {
    title: "Items",
    key: "details_count"
  },

  {
    title: "Status",
    key: "status"
  },

  {
    title: "Actions",
    key: "actions"
  },

];

/* ================= GETTERS ================= */

const getPriceInquiryList = computed(() => {
  return store.getters.getPriceInquiryList || [];
});

const getCustomerList = computed(() => {
  return store.getters.getCustomerList || [];
});

/* ================= METHODS ================= */

const loadPriceInquiryList = async () => {

  try {

    store.commit("SET_LOADING", true);

    await store.dispatch(
      "getPriceInquiries",
      {
        from_date: from_date.value,
        to_date: to_date.value,
        customer_id: customer_id.value,
      }
    );

  } catch (error) {

    console.error(error);

  } finally {

    store.commit("UNSET_LOADING");

  }

};

const viewItem = (item) => {

  selectedItem.value = item;

    router.push({
        name: "price-inquery-details",
        params: {
            id: item.id
        }
    });

//   showViewModal.value = true;

};

const editItem = (item) => {

  router.push({
    name: "price-inquery",
    params: {
      id: item.id
    }
  });

};

onMounted(async () => {

  await store.dispatch(
    "getCustomerList"
  );

  await loadPriceInquiryList();

});
</script>